import { Routes } from '@angular/router';
import { Master } from './Layout/master/master';
import { Home } from './Page/home/home';
import { MandaviSMishra } from './Page/mandavi-s-mishra/mandavi-s-mishra';
import { RedmonkWellness } from './Page/redmonk-wellness/redmonk-wellness';
import { MotivatedToHelpCustomersStayHealthyConfident } from './Page/motivated-to-help-customers-stay-healthy-confident/motivated-to-help-customers-stay-healthy-confident';
import { Thankyou } from './Page/thankyou/thankyou';
import { Error } from './Page/error/error';
import { Package } from './Page/package/package/package';
import { PackageEnquire } from './Page/package/package-enquire/package-enquire';
import { PackageThankyou } from './Page/package/package-thankyou/package-thankyou';
import { PressMedia } from './Page/press-media/press-media';
import { AshimMatthan } from './Page/ashim-matthan/ashim-matthan';
import { DrKanishkaJain } from './Page/dr-kanishka-jain/dr-kanishka-jain';
import { Blog } from './Page/blog/blog';
import { Bakerycarnival } from './Page/bakerycarnival/bakerycarnival';
import { ContestFormThankyou } from './Page/contest-form-thankyou/contest-form-thankyou';
import { ContestFormError } from './Page/contest-form-error/contest-form-error';
import { DeepakDas } from './Page/deepak-das/deepak-das';
import { PrivacyPolicy } from './Page/privacy-policy/privacy-policy';
import { TermsConditions } from './Page/terms-conditions/terms-conditions';
import { Ourteam } from './Page/ourteam/ourteam';
import { Aboutus } from './Page/aboutus/aboutus';
import { Howitworks } from './Page/howitworks/howitworks';
import { Benefits } from './Page/benefits/benefits';
import { Contactus } from './Page/contactus/contactus';
import { Treatments } from './Page/treatments/treatments';
import { Houseofhydration } from './Page/houseofhydration/houseofhydration';
import { Timelessmonk } from './Page/timelessmonk/timelessmonk';
import { Hairtreatments } from './Page/hairtreatments/hairtreatments';
import { Skinboosters } from './Page/skinboosters/skinboosters';
import { Signaturefacialsglowtreatments } from './Page/signaturefacialsglowtreatments/signaturefacialsglowtreatments';
import { Advancedskintreatmentspeels } from './Page/advancedskintreatmentspeels/advancedskintreatmentspeels';
import { BlogDetails } from './Page/blog-details/blog-details';
import { Bookconsultation } from './Page/bookconsultation/bookconsultation';
import { SkinTighteningRejuvenation } from './Page/skin-tightening-rejuvenation/skin-tightening-rejuvenation';
import { LaserRemovalTreatments } from './Page/laser-removal-treatments/laser-removal-treatments';
import { SkinConcernTreatments } from './Page/skin-concern-treatments/skin-concern-treatments';
import { BridalLuxuryPrograms } from './Page/bridal-luxury-programs/bridal-luxury-programs';
import { ConsultationAnalysis } from './Page/consultation-analysis/consultation-analysis';
import { KolkataService } from './Page/kolkata-service/kolkata-service';
import { KOLKATA_PAGES } from './Page/kolkata-service/kolkata-pages.data';

// Six Kolkata landing pages (direct URLs only; intentionally not in the navigation)
const kolkataRoutes: Routes = KOLKATA_PAGES.map((p) => ({
  path: p.slug.replace(/^\//, ''),
  component: KolkataService,
  data: {
    title: p.title,
    description: p.description,
    canonicalUrl: 'https://www.redmonkwellness.com' + p.slug + '/',
    city: 'kolkata',
    kolkataId: p.id,
  },
}));

//import { Categorytreatments } from './Page/category-treatments/category-treatments';

export const routes: Routes = [
  // Default redirect to Home
  { path: '', redirectTo: 'home', pathMatch: 'full' },

  // Master layout wrapper
  {
    path: '',
    component: Master,
    children: [
      { path: 'home', component: Home },
      { path: 'index', redirectTo: 'home', pathMatch: 'full' },
      { path: 'mandavi-s-mishra', component: MandaviSMishra },
      {
        path: 'motivated-to-help-customers-stay-healthy-confident',
        component: MotivatedToHelpCustomersStayHealthyConfident,
      },
      { path: 'redmonk-wellness', component: RedmonkWellness },
      { path: 'thankyou', component: Thankyou },
      { path: 'error', component: Error },
      { path: 'package', component: Package },
      { path: 'package-enquire', component: PackageEnquire },
      { path: 'package-thankyou', component: PackageThankyou },
      { path: 'press-media', component: PressMedia },
      { path: 'ashim-matthan', component: AshimMatthan },
      { path: 'dr-kanishka-jain', component: DrKanishkaJain },
      { path: 'blog', component: Blog },

      { path: 'bakerycarnival', component: Bakerycarnival },
      { path: 'contest-form-thankyou', component: ContestFormThankyou },
      { path: 'contest-form-error', component: ContestFormError },
      { path: 'deepak-das', component: DeepakDas },

      // {
      //   path: 'FiveCommonMistakesPeopleMakeWithIVTherapy',
      //   component: FiveCommonMistakesPeopleMakeWithIVTherapy,
      // },
      // { path: 'Gettheredmonkadvantage', component: Gettheredmonkadvantage },
      // { path: 'WhichFacialIsBestForYou', component: WhichFacialIsBestForYou },
      // { path: 'IVHydration', component: IVHydration },
      // { path: 'WellnessSpecial', component: WellnessSpecial },
      // { path: 'StregthEndurance', component: StregthEndurance },
      { path: 'privacy-policy', component: PrivacyPolicy },
      // { path: 'AgeingSkin', component: AgeingSkin },
      // { path: 'Wanttolook10yearsyounger', component: Wanttolook10yearsyounger },
      { path: 'terms-conditions', component: TermsConditions },
      // { path: 'Wedeliverwhatwepromise', component: Wedeliverwhatwepromise },
      { path: 'ourteam', component: Ourteam },
      { path: 'aboutus', component: Aboutus },
      { path: 'howitworks', component: Howitworks },
      { path: 'benefits', component: Benefits },
      { path: 'contactus', component: Contactus },
      {
        path: 'treatments',
        component: Treatments,
        data: {
          title: 'Skin, Hair & Aesthetic Treatments in Mumbai | Red Monk Wellness',
          description:
            'Explore advanced skin, hair and aesthetic treatments at Red Monk Wellness in Mumbai, including hair fall therapy, skin boosters, facials, peels, skin tightening, laser treatments and bridal skin programs',
          canonicalUrl: 'https://www.redmonkwellness.com/treatments',
        },
      },
      { path: 'houseofhydration', component: Houseofhydration },
      { path: 'timelessmonk', component: Timelessmonk },

      { path: 'hairtreatments', component: Hairtreatments },
      { path: 'skinboosters', component: Skinboosters },
      { path: 'signaturefacialsglowtreatments', component: Signaturefacialsglowtreatments },
      { path: 'advancedskintreatmentspeels', component: Advancedskintreatmentspeels },
      { path: 'skinTighteningRejuvenation', component: SkinTighteningRejuvenation },
      { path: 'laserRemovalTreatment', component: LaserRemovalTreatments },
      { path: 'skin-concern-treatments', component: SkinConcernTreatments },
      { path: 'bridal-luxury-programs', component: BridalLuxuryPrograms },
      { path: 'consultation-analysis', component: ConsultationAnalysis },
      ...kolkataRoutes,

      {
        path: 'blog-details/:id',
        loadComponent: () => import('./Page/blog-details/blog-details').then((m) => m.BlogDetails),
      },
      { path: 'bookconsultation', component: Bookconsultation },
      // { path: 'treatments/:slug', component: Categorytreatments },
    ],
  },

  // Redirect unknown routes
  { path: '**', redirectTo: 'home' },
];
